import { Icon, IconProps } from "@chakra-ui/react";
import { MdSchedule } from "react-icons/md";

export default function TimeIcon(props: IconProps) {
  return (
    <Icon
      as={MdSchedule}
      boxSize="1em"
      verticalAlign="middle"
      mb=".15em"
      {...props}
    />
  );
}
